// Same API domain as web2. Production coin host -> production API, everything else -> UAT.
const PROD_HOSTS = ['coin.nexusgoldinternational.com'];
const isProd = PROD_HOSTS.includes(window.location.hostname);
const isLocal = window.location.hostname === 'localhost';

const config = {
  // VUE_APP_API_URL (e.g. in .env.local) overrides for local backend testing
  url: process.env.VUE_APP_API_URL || (isProd
    ? 'https://api.nexusgold-international.com/'
    : 'https://uatapi.nexusgold-international.com/'),
  // web2 member site, used for login redirect and "back to member centre"
  // local dev: web2 runs on localhost:8080
  memberUrl: isProd
    ? 'https://member.nexusgoldinternational.com/web'
    : isLocal
      ? 'http://localhost:8080/web'
      : 'https://uat.nexusgoldinternational.com/web',
  // team reward (referral / matrix) UI is hidden until the reward rules are final
  showTeam: false,
  // release / yield page is hidden for now
  showRelease: false,
};

export default config;
